import { render, staticRenderFns } from "./UserRegSetupAccComponent.vue?vue&type=template&id=4a66e4c8&scoped=true"
import script from "./UserRegSetupAccComponent.vue?vue&type=script&lang=js"
export * from "./UserRegSetupAccComponent.vue?vue&type=script&lang=js"
import style0 from "./UserRegSetupAccComponent.vue?vue&type=style&index=0&id=4a66e4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66e4c8",
  null
  
)

export default component.exports